import { logged_in as loggedIn } from 'state';
import routingSettings from '../config/routing_config';
import show from './show';
import { getAccountData, getAccountRestriction } from './account';
import errorMessage from '../modals/error';
import { loggedInConfigurations } from '../config/base_config';
import userSettings from '../config/user_config';
import { loggedInRouting, loggedOutRouting } from './routing';
import { translate as t } from '../../i18n/translations';

const showLivechat = () => {
  if (loggedIn()) {
    // Check if user is allowed to chat
    getAccountRestriction()
      .then(({ success, allowed }) => {
        if (success && allowed) {
          getAccountData().then((data) => {
            // apply user settings;
            loggedInConfigurations(data);
            userSettings(data);
            // apply routing
            loggedInRouting(data.customer_service_level);
          })
            .then(() => show());
        } else if (success && !allowed) {
          errorMessage(t('javascript.zendesk.error.restricted_use'));
        } else {
          errorMessage(t('something_went_wrong_try_again'));
        }
      });
  } else {
    loggedOutRouting();
    show();
  }
};

export default (service) => {
  window.zE('webWidget', 'updateSettings', routingSettings(service));
  if (service === 'chat') {
    showLivechat();
  } else {
    show();
  }
};
